import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LayoutContainerComponent } from './layout/layout-container/layout-container.component';
import { PublicLayoutComponent } from './layout/public-layout/public-layout.component';
import { ComingSoonComponent } from './pages/extra-pages/coming-soon/coming-soon.component';
import { Error404Component } from './pages/extra-pages/error404/error404.component';
import { Error500Component } from './pages/extra-pages/error500/error500.component';
import { MaintenanceComponent } from './pages/extra-pages/maintenance/maintenance.component';
import { CalendarioHitosComponent } from './calendario-hitos/calendario-hitos.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  /*
  {
    path: 'usuarios',
    component: UsuariosComponent,
    canActivate: [AuthGuard],
    children: UsuariosRoutes
  },
  */
  {
    path: '',
    component: LayoutContainerComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
      },
      {
        path: 'apps',
        loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule)
      },
      {
        path: 'usuarios',
        loadChildren: () => import('./usuarios/usuarios.module').then(m => m.UsuariosModule)
      },
      {
        path: 'arbitros',
        loadChildren: () => import('./arbitros/arbitros.module').then(m => m.ArbitrosModule)
      },
      {
        path: 'plantillas',
        loadChildren: () => import('./plantillas/plantillas.module').then(m => m.PlantillasModule)
      },
      {
        path: 'casos',
        loadChildren: () => import('./casos/casos.module').then(m => m.CasosModule)
      },
      {
        path: 'representantes',
        loadChildren: () => import('./representantes/representantes.module').then(m => m.RepresentantesModule)
      },
      {
        path: 'log-plataforma',
        loadChildren: () => import('./log/log-plataforma.module').then(m => m.LogPlataformaModule)
      },
      {
        path: 'buscador-archivos',
        loadChildren: () => import('./buscador-archivos/buscador-archivos.module').then(m => m.BuscadorArchivosModule)
      },
      {
        path: 'informes',
        loadChildren: () => import('./informes/informes.module').then(m => m.InformesModule)
      },
      {
        path: 'calendario-hitos',
        component: CalendarioHitosComponent
      }
    ]
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
      {
        path: 'error-404',
        component: Error404Component
      },
      {
        path: 'error-500',
        component: Error500Component
      },
      {
        path: 'maintenance',
        component: MaintenanceComponent
      },
      {
        path: 'coming-soon',
        component: ComingSoonComponent
      },
      { path: 'landing', loadChildren: () => import('./pages/landing/landing.module').then(m => m.LandingModule) }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
